export default __webpack_public_path__ + "static/media/ConnectButton.ca14581b.png";